<!-- 缺陷reopen -->
<template>
  <div>
    <a-card title="迭代任务状态分布" size="small">
      <div id="version-task-status" :style="{ height: height, width: width }" />
    </a-card>
    <a-modal :visible="modalVisible" :title="title" :closable="false" :width="800" @cancel="closeModal">
      <a-table :columns="columns" :data-source="tableData" :width="700">
        <span slot="name" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.name">
            <a class="custom-link" :href="taskLink(record)" target="_blank">{{ record.name }}</a>
          </a-tooltip>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="taskStatus[record.status]" :color="taskStatus[record.status].color">{{ taskStatus[record.status].label }}</a-tag>
        </span>
      </a-table>
      <div slot="footer" />
    </a-modal>
  </div>
</template>
<script>
import { getDiagramInfo } from '@/api/data/quality';
import { taskStatus } from '@/utils/dictionary';
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '250px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    taskMap: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      myChart: null,
      modalVisible: false,
      title: '',
      tableData: [],
      columns: [
        {
          title: 'id',
          dataIndex: 'id',
          key: 'id',
          scopedSlots: { customRender: 'id' }
        },
        {
          title: '任务名',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: { customRender: 'name' }
        }
      ],
      option: {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {},
        series: [
          {
            name: null,
            type: 'pie',
            radius: '60%',
            center: ['50%', '58%'],
            data: [],
            label: {
              // formatter: '{b}: {@2012} ({d}%)',
              formatter: params => {
                return params.name + ': ' + params.value + ' (' + params.percent.toFixed(1) + '%)';
              }
            },
            itemStyle: {
              borderRadius: 6,
              borderColor: '#fff',
              borderWidth: 2
            },
            emphasis: {
              label: {
                show: true,
                fontWeight: 'bold'
              }
            }
          }
        ]
      }
    };
  },
  computed: {
    taskLink() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:project:task:detail',
          query: { taskId: record.id },
          params: { project_id: record.project }
        });
        return route.href;
      };
    }
  },
  watch: {
    filterForm() {
      this.getDiagramData();
    }
  },
  mounted() {
    // let echarts = require('echarts');
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/pie'); // 饼图
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    this.myChart = echarts.init(document.getElementById('version-task-status'));
    this.myChart.on('click', params => {
      this.tableData = params.data.detail;
      this.modalVisible = true;
      this.title = params.data.name;
    });
    setTimeout(() => {
      this.getDiagramData();
    }, 100); // 添加延迟
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    closeModal() {
      this.modalVisible = false;
    },
    drawChart() {
      this.myChart.setOption(this.option);
      window.addEventListener('resize', () => {
        this.myChart.resize();
      });
    },
    getDiagramData() {
      getDiagramInfo(this.filterForm).then(res => {
        this.option.series[0].data = [
          {
            value: res.data.not_begin.length,
            name: '未开始',
            itemStyle: { color: '#FFAB33' },
            detail: res.data.not_begin
          },
          {
            value: res.data.doing.length,
            name: '进行中',
            detail: res.data.doing
          },
          {
            value: res.data.done.length,
            name: '已完成',
            detail: res.data.done
          },
          {
            value: res.data.ask_for_test.length,
            name: '已提审',
            detail: res.data.ask_for_test
          },
          {
            value: res.data.qa_verify.length,
            name: '质量验收中',
            detail: res.data.qa_verify
          },
          {
            value: res.data.prd_deploy.length,
            name: '部署上线中',
            detail: res.data.prd_deploy
          },
          {
            value: res.data.finish.length,
            name: '已上线',
            detail: res.data.finish
          }
        ];
        this.drawChart();
      });
    }
  }
};
</script>
